import React, {useEffect} from 'react';

const ExternalRedirect = ({url}) => {
    useEffect(() => {
        if (window.location.pathname !== url) {
            window.location.href = url;
        }
    });

    return <h3 className="text-center">Redirecting...</h3>;
};

export default ExternalRedirect;